import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import{ Component } from 'react';
import Slider from 'react-slick';
import {
  StyledWhereSpaces,
  StyledWhereSpacesSlide,
  StyledWhereSpacesSlideCaption,
  StyledWhereSpacesSlideImg,
} from './WhereSpaces.styled';

class WhereSpaces extends Component {
  render() {
    const settings = {
      dots: true,
      arrows: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    const spacesSlides = this.props.spacesSlides;

    return (
      <StyledWhereSpaces>
        <Slider {...settings}>
          {spacesSlides.map((s, i) => (
            <StyledWhereSpacesSlide key={i}>
              <StyledWhereSpacesSlideImg src={s.img} alt="" />
              <StyledWhereSpacesSlideCaption>
                <FontAwesomeIcon icon={faInfoCircle} />
                {s.caption}
              </StyledWhereSpacesSlideCaption>
            </StyledWhereSpacesSlide>
          ))}
        </Slider>
      </StyledWhereSpaces>
    );
  }
}

export default WhereSpaces;
